import { Suspense } from 'react';
import { Title, Typography } from '@optimus-web/core';
import { Loader } from '@mews-commander/ui';
import { lt, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { ItemsFields } from './items/ItemsFields';
import { ConditionsFields } from './Conditions/ConditionsFields';
import { ConflictsDialog } from './conflicts/ConflictsDialog';

export const ItemsAndConditionsFields = () => {
    const newRoutingRulesPOSEnabled = useFeatureFlag(FeatureFlag.newRoutingRulesPOSEnabled);
    return (
        <Suspense fallback={<Loader />}>
            <Title level={2} align="left">
                {lt(TextKey.RoutingRulesFormFieldTitleItems)}
                {newRoutingRulesPOSEnabled ? null : UnicodeEntity.Asterisk}
            </Title>
            <Typography variant="secondary" textStyle="bodyMedium" as="div">
                {lt(TextKey.RoutingRulesFormFieldDescriptionItems)}
            </Typography>
            <ItemsFields />
            <Title level={2} align="left">
                {lt(TextKey.RoutingRulesFormFieldTitleConditions)}
            </Title>
            <Typography variant="secondary" textStyle="bodyMedium" as="div">
                {lt(TextKey.RoutingRulesFormFieldDescriptionConditions)}
            </Typography>
            <ConditionsFields />
            <ConflictsDialog />
        </Suspense>
    );
};
